import React from "react"
import Switch from "../../Switch/Switch"
import clsx from "clsx"


export default class DailyRatePresenterGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="general">
        <div className="RatesDashboardRoomTypeRateDateOverrides">
          <div className="daily-room-type-price-row-form">
            <div className="row">
              <div className="col-xs-6">
                <div className="form-group">
                  <label>{I18n.t('amount')}</label>
                  <div> <span>{I18n.t('number.currency.format.unit')}</span>
                    {(this.props.amount/ 100).toFixed(2)}
                  </div>
                  {/* <div className="input-group input-group-currency" style={{marginLeft: 0}}>
                    <div className="input-group-addon">{I18n.t('number.currency.format.unit')}</div>
                    <div>{this.props.amount}</div>
                  </div> */}
                  {/* <div className="default-value-helper-text">
                    <em>{this.props.base_amount ? <span>{I18n.t('number.currency.format.unit')}{numeral(this.props.base_amount / 100).format('0,000.00')}</span> : I18n.t('none')}</em>

                  </div> */}
                </div>
              </div>
              <div className="col-xs-6">
                <div className="form-group">
                  <label>{I18n.t('min_stay')}</label>
                  <div>{this.props.minimum_stay}</div>
                  {/* <NumberSpinner name="minimum_stay" value={this.state.minimum_stay} onChange={this.onChange} /> */}
                  {/* <div className="default-value-helper-text"><em>{this.props.minimum_stay || I18n.t('none')}</em></div> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <div className="form-group">
                  <label>{I18n.t('blackout')} <span className="ss-help help" title={I18n.t('blackout_helper_text')}></span></label>
                  <Switch onText="enabled" offText="disabled" disabled={true} defaultValue={this.props.blackout} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
